import moment from 'moment'

export function formatDate (date, format = null) {
  return moment(date).format(format || 'MMMM DD, YYYY')
}

export function formatFolderName (folder) {
  if (typeof folder !== 'undefined' && folder !== null && folder.length) {
    let folders = folder.split(':')
    if (folders.length - 2 > 0) {
      return folders[folders.length - 2]
    }
  }
  return ''
}

export function formatRootFolderName (folder) {
  folder = folder.replace(/['"]+/g, '')
  if (typeof folder !== 'undefined' && folder !== null && folder.length) {
    let folders = folder.split(':')
    if (folders.length) {
      return folders[folders.length - 1].trim()
    }
  }

  return ''
}
